// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + chunkId + "." + {"6814": "20ef4215f3a9fdcd","7173": "b4da781d0591c403",}[chunkId] + ".chunk.js"
}